// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dkhqvxbmigvhtzbjhbrf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRraHF2eGJtaWd2aHR6YmpoYnJmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMwNzY4ODgsImV4cCI6MjA2ODY1Mjg4OH0.mCilJFu9W-oXl094lXTVRM9p1q_nR-2kOnD8Oyi9pXA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});